// Show Arabic PDP metafields (custom.*_ar) when the page is Arabic
      (function syncPdpMetafieldLanguage() {
        const isArabicPage = () => {
          const html = document.documentElement;
          const lang = (html.getAttribute('lang') || '').toLowerCase();
          const path = (window.location.pathname || '').toLowerCase();
          return (
            html.classList.contains('is-arabic') ||
            lang === 'ar' ||
            lang.startsWith('ar-') ||
            path.includes('/ar/') ||
            path.includes('/ar-')
          );
        };

        const apply = () => {
          const arabic = isArabicPage();
          if (arabic) {
            document.documentElement.classList.add('is-arabic');
            document.documentElement.setAttribute('dir', 'rtl');
          }

          document.querySelectorAll('[data-pdp-mf]').forEach((root) => {
            const en = root.querySelector('[data-pdp-mf-lang="en"]');
            const ar = root.querySelector('[data-pdp-mf-lang="ar"]');
            const arText = ar ? (ar.textContent || '').trim() : '';
            const enText = en ? (en.textContent || '').trim() : '';

            if (arabic) {
              if (ar && arText) {
                if (en) en.hidden = true;
                ar.hidden = false;
              } else if (en && enText) {
                en.hidden = false;
                if (ar) ar.hidden = true;
              }
            } else {
              if (en) en.hidden = !enText;
              if (ar) ar.hidden = true;
            }
          });
        };

        apply();
        document.addEventListener('DOMContentLoaded', apply);
        document.addEventListener('shopify:section:load', apply);
        document.addEventListener('variant:update', apply);
      })();
